// Module
var code = "<div ref=\"header\"></div>\n<div class=\"booking-element-container\" ref=\"container\"></div>";
// Exports
module.exports = code;